import axios from 'axios'
import GoogleOneTapLogin from 'react-google-one-tap-login'
import { toast as sonnerToast } from 'sonner'
import { Toast } from '@velasca/ui/toast'
import { getVelascaApiUrl } from '@velasca/utils/get-velasca-api-url'
import { $settings } from '@velasca/utils/globals'

const velascaApiUrl = getVelascaApiUrl(process.env.NODE_ENV)

interface HandleResponseProps {
  email: string
  family_name: string
  given_name: string
}

export const GoogleOneTapLoginHelper = () => {
  const handleSuccess = ({
    email,
    family_name,
    given_name,
  }: HandleResponseProps) => {
    if (!email) {
      return
    }

    const data = JSON.stringify({
      email,
      family_name,
      given_name,
      return_to: window.location.href,
    })

    axios
      .post(`${velascaApiUrl}/multipass/auth`, data)
      .then(({ data: { redirect_url } }) => {
        if (!redirect_url) {
          return
        }

        const DELAY_AMOUNT = 3000

        sonnerToast.custom(
          () => (
            <Toast
              variant="success"
              message={
                $settings.google_one_tap_login_success_message ?? 'Logged-in.'
              }
              onCancel={() => sonnerToast.dismiss()}
            />
          ),
          { duration: DELAY_AMOUNT },
        )
        setTimeout(() => {
          window.location.href = redirect_url
        }, DELAY_AMOUNT)
      })
      .catch((error) => {
        console.error(error)
        sonnerToast.custom(() => (
          <Toast
            variant="error"
            message="Errore. Impossibile loggare l'utente al momento."
            onCancel={() => sonnerToast.dismiss()}
          />
        ))
      })
  }

  // eslint-disable-next-line unicorn/consistent-function-scoping
  const handleFailure = (error?: string | Error) => {
    console.error(error)
    sonnerToast.custom(() => (
      <Toast
        variant="error"
        message="Errore. Impossibile loggare l'utente al momento."
        onCancel={() => sonnerToast.dismiss()}
      />
    ))
  }

  return (
    window.customerID === 'unknown' &&
    $settings.google_clientid && (
      <GoogleOneTapLogin
        disabled={window.navigator.webdriver}
        googleAccountConfigs={{
          client_id: $settings.google_clientid,
        }}
        onSuccess={handleSuccess}
        onError={handleFailure}
      />
    )
  )
}
